import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import ProductArea from "./components/layout2/ProductArea";
import StepsArea from "./components/layout2/StepsArea";
import TopArea from "./components/layout2/TopArea";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import localStorageKey from "../../enumerations/localStorageKey";
import { scrollToElementById } from "../../plugins/scrollFunction";
import styles from "./style.module.scss";

const Home = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = useState<number | string>("");
  const [promoteCode, setPromoteCode] = useState(searchParams.get("code"));

  const location = useLocation();

  useEffect(() => {
    if (location?.state?.area) {
      scrollToElementById(location.state.area);
    } else {
    }
  }, [location]);

  useEffect(() => {
    if (promoteCode) {
      window.localStorage.setItem(localStorageKey.PROMOTE_CODE, promoteCode);
    }
  }, [promoteCode]);

  useEffect(() => {
    const haveCart = localStorage.getItem(localStorageKey.HAVE_CART);
    if (haveCart) {
      navigate("/cart");
      localStorage.removeItem(localStorageKey.HAVE_CART);
    }
  }, [navigate]);

  return (
    <div className={styles.homeContainer}>
      <TopArea />
      <ProductArea
        setSelectedCountry={setSelectedCountry}
        selectedCountry={selectedCountry}
      />
      <StepsArea />
    </div>
  );
};

export default Home;
